import { Message } from 'element-ui'
import i18n from '@/i18n'

export default {
  success: (key, params) => Message.success(i18n.t(key, params)),
  warn: (key, params) => Message.warning(i18n.t(key, params)),
  error: (key, params) => Message.error(i18n.t(key, params))
}
